const QRCode = require("qrcode");

/**
 * generateQR(text[, options]) -> Promise<string>
 * Returns a PNG Data URL for the QR code.
 */

// async function generateQR(text, options = {}) {
//   const dataUrl = await QRCode.toDataURL(String(text), options);

//   if (options.inject === true) {
//     injectIntoDOM(text, dataUrl, options);
//   }

//   return dataUrl;
// }

// function injectIntoDOM(text, dataUrl, options) {
//   const el = document.getElementById(options.targetId || "qrcode");
//   if (!el) return;

//   // Detect mobile
//   const isMobile =
//     typeof navigator !== "undefined" &&
//     ((navigator.userAgentData && navigator.userAgentData.mobile === true) ||
//       /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || ""));

//   const img = document.createElement("img");
//   img.src = dataUrl;
//   img.alt = options.alt || "QR Code";
//   img.style.display = "block";
//   img.style.margin = "0 auto";

//   if (isMobile) {
//     // Wrap in <a> to make clickable on mobile
//     const a = document.createElement("a");
//     a.href = String(text);
//     a.target = "_blank";
//     a.rel = "noopener noreferrer";
//     a.title = options.title || "Open QR in new tab";
//     a.style.display = "block";
//     a.style.margin = "0 auto";

//     a.appendChild(img);
//     el.parentNode.replaceChild(a, el);
//   } else {
//     // Just replace with the image on desktop
//     el.parentNode.replaceChild(img, el);
//   }
// }
async function generateQR(text, options = {}) {
  const dataUrl = await QRCode.toDataURL(String(text), options);

  // If running in a browser with a DOM, replace the div with id 'qrcode'
  try {
    if (
      typeof document !== "undefined" &&
      document &&
      typeof document.getElementById === "function"
    ) {
      const el = document.getElementById("qrcode");
      if (el && el.parentNode) {
        const img = document.createElement("img");
        img.src = dataUrl;
        img.alt = options.alt || "QR Code";
        // preserve the id so other code can still find it if needed
        img.id = el.id;
        if (options.className) img.className = options.className;
        if (typeof options.width === "number") img.width = options.width;
        if (typeof options.height === "number") img.height = options.height;

        // make the image clickable and open the QR in a new tab
        try {
          if (typeof window !== "undefined" && window) {
            // detect Android/iOS (prefer userAgentData when available)
            const isMobile =
              typeof navigator !== "undefined" &&
              ((navigator.userAgentData &&
                navigator.userAgentData.mobile === true) ||
                /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || ""));

            // only expose click behaviour on mobile devices (Android / iOS)
            if (isMobile) {
              // wrap the image in an anchor so the browser handles opening a new tab
              const a = document.createElement("a");
              a.href = String(text);
              a.target = "_blank";
              a.rel = "noopener noreferrer";
              a.title = options.title || "Open QR in new tab";
              a.style.cursor = "pointer";
              a.style.display = "block";
              a.style.margin = "auto";

              // preserve the original id on the anchor so other code can still find it
              a.id = el.id;
              // move className to the anchor if provided, keep image clean
              if (options.className) a.className = options.className;

              // clear id on img to avoid duplicate ids
              img.id = "";
              img.style.display = "block";
              img.style.margin = "0";

              a.appendChild(img);
              el.parentNode.replaceChild(a, el);
            } else {
              // not mobile: do not attach click handler; keep default cursor
              img.style.cursor = "";
              el.parentNode.replaceChild(img, el);
            }
          }
        } catch (attachErr) {
          console.log("Error attaching QR code to DOM:", attachErr);
        }

        el.parentNode.replaceChild(img, el);
      }
    }
  } catch (domErr) {
    // don't fail the promise if DOM manipulation fails; just ignore DOM errors
    // (keeps behavior safe when used in unexpected environments)
  }

  return dataUrl;
}

/**
 * checkStatus(id, callback)
 * Asynchronously checks status and calls callback(err, result).
 * This is a simulated implementation — replace with real API/DB logic as needed.
 */
function checkStatus(id, callback) {
  if (typeof callback !== "function") {
    throw new TypeError("callback must be a function");
  }

  // simulate async work
  setTimeout(() => {
    // basic validation
    if (id == null || id === "") {
      return callback(new Error("invalid id"));
    }

    const result = { id, status: "ready", checkedAt: new Date().toISOString() };
    callback(null, result);
  }, 200);
}

module.exports = { generateQR, checkStatus };
